document.addEventListener('DOMContentLoaded', function() {
  const popup = document.getElementById('custom-popup');
  const overlay = document.getElementById('custom-popup-overlay');
  const closeButton = document.querySelector('.custom-popup-close');
  const contactForm = document.getElementById('popup-contact-form');
  const signupContent = document.getElementById('popup-content-signup');
  const successContent = document.getElementById('popup-content-success');

  const wasPopupShown = sessionStorage.getItem('popupShown');

  if (!wasPopupShown) {
    setTimeout(function() {
      if(popup && overlay) {
        popup.style.display = 'block';
        overlay.style.display = 'block';
      }
      sessionStorage.setItem('popupShown', 'true');
    }, 2000);
  }

  function closePopup() {
    if(popup && overlay) {
      popup.style.display = 'none';
      overlay.style.display = 'none';
    }
  }

  if(closeButton) closeButton.addEventListener('click', closePopup);
  if(overlay) overlay.addEventListener('click', closePopup);

  // Nova parte: Lidar com o envio do formulário
  if(contactForm) {
    contactForm.addEventListener('submit', function(e) {
      e.preventDefault(); // Impede o recarregamento da página

      const formData = new FormData(contactForm);

      fetch('/contact', {
        method: 'POST',
        body: formData,
      })
      .then(response => {
        if (response.ok) {
          // Se o envio deu certo, troca o conteúdo
          signupContent.style.display = 'none';
          successContent.style.display = 'block';
        } else {
          // Se deu erro, podemos alertar o usuário
          alert('Ocorreu um erro. Tente novamente.');
        }
      })
      .catch(error => console.error('Error:', error));
    });
  }
});